﻿<script setup lang="ts">
import {computed} from 'vue';
import {Icon} from '@iconify/vue';
import type {PartInfo} from '@/generated';
import {storeToRefs} from 'pinia';
import {useSettingsStore} from "@/stores/settings.ts";
import {useMusicUploadStore} from "@/stores/useMusicUploadStore.ts";
import BlurOnLoad from "@/components/BlurOnLoad.vue";
import {stableBySignature} from "@/stores/historyMemo";

const uploadStore = useMusicUploadStore();
const conversionStore = uploadStore

const {analysisResult, isPending} = storeToRefs(conversionStore);


let settingsStore = useSettingsStore();


const selectedParts = settingsStore.field('selected_parts');

const safeSelectedParts = computed<number[]>(() => selectedParts.value ?? []);

// Signaturvergleich statt Längenvergleich: gleich viele, aber andere Parts (Dateiwechsel)
// lieferten sonst die veraltete Liste zurück.
const parts = computed<PartInfo[]>(stableBySignature(
    () => (analysisResult.value?.parts ?? []) as PartInfo[],
    (items) => items.map((p) => `${p.index}|${p.name}|${p.instrument ?? ''}`).join(';'),
));

function togglePart(index: number) {
  const current = safeSelectedParts.value;
  const exists = current.includes(index);
  const next = exists
      ? current.filter((i: number) => i !== index)
      : [...current, index];
  settingsStore.setSelectedParts(next);
}



</script>

<template>
  <div
      v-if="parts.length && parts.length>1"
      class="relative p-0 grid grid-cols-1 gap-2 bg-blue-50 rounded-xl border border-blue-200 text-lg"
 >
    <BlurOnLoad />

  <div>
<!--    <div class="w-24 bg-gray-300  h-6 rounded-md ">-->
<!--    </div>-->
    <h3 class="flex font-medium items-center p-3 rounded-lg border border-gray-100">
      <Icon icon="fa6-solid:layer-group" class="mr-1"/>
      Stimmen auswählen:
    </h3>
    <div class="grid lg:grid-cols-2">
      <template
          v-for="part in parts"
          :key="part.index"
      >
        <label


            class="flex items-center text-sm py-1 rounded-lg border border-gray-100 hover:bg-gray-50 cursor-pointer transition-colors"
        >
          <input

              class="ml-3  font-medium text-gray-700"
              type="checkbox"
              :value="part.index"
              :checked="safeSelectedParts.includes(part.index)"
              @change="togglePart(part.index)"
          />
          <span>
          {{ part.name }}<span v-if="part.instrument"> ({{ part.instrument }})</span>
        </span>
        </label>
      </template>
    </div>

  </div>
  </div>
</template>
